import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import { ResetPassword, ResetPasswordValidation, UserLogin } from '../../Data';

const ResetPass = (props) => {
    const [email, setEmail] = useState("");
    const [confirmPassword, setConfirmPassword] = useState('');
    const [password, setPassword] = useState("");
    const [old, setOld] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!ResetPasswordValidation(password, confirmPassword)) return;

        try {
            // 1️⃣ Reset password
            await ResetPassword(email, old, password);

            // 2️⃣ Login again (same as Login page)
            const Result = await UserLogin(email, password);

            // 3️⃣ SAME cookies as login
            // props.setSubscribe(Result.IsSubscribed);

            Cookies.set('User', email, { expires: 5 });
            Cookies.set('WishList', Result.WishlistId, { expires: 5 });
            Cookies.set('Cart', Result.CartId, { expires: 5 });
            Cookies.set('Subscribe', Result.IsSubscribed, { expires: 5 });
            Cookies.set('Number', Result.CustomerId, { expires: 5 });
            Cookies.set('CustomerToken', Result.Token, { expires: 5 });

            toast.success("Password reset successful");

            // 4️⃣ SAME redirect behavior
            window.location.href = "/Account";

        } catch (error) {
            const message = error?.message?.replaceAll('"', "");

            if (message === "Please Confirm Your Email") {
                navigate("/Email-Confirmation");
            } else if (message === "Please Reset Your Password") {
                navigate("/Reset-Password");
            }

            toast.error(message || "Error");
        }
    };

    return (
        <>
            {/* UI stays EXACTLY the same */}
            <div className="breadcrumb-area mb-50">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="breadcrumb-container">
                                <ul>
                                    <li><a href="index.html"><i className="fa fa-home"></i> Home</a></li>
                                    <li className="active">Reset Password</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center mt-2">
                <div className="col-12 col-md-8">
                    <div className="authenticationCard">
                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>Email</label></div>
                            <div className="col-12 col-md-10">
                                <input type="email" className="form-control" required
                                    onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>Old Password</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" required
                                    onChange={(e) => setOld(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>New Password</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" required
                                    onChange={(e) => setPassword(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>Confirm Password</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" required
                                    onChange={(e) => setConfirmPassword(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3 submit">
                            <div className="col-12 text-center">
                                <button className="Resend-button mt-0 RemUnderline"
                                    onClick={handleSubmit}>
                                    Reset Password
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPass;
